import createStore from '@Stores/base-factories'
import { hookMetaFieldList } from '@Stores/base-factories/store-list'
import hookSiteSelectedFactory from '@Stores/base-factories/store-site-selection'

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('meta-field')
  .extendHookCollectionsFactory('meta-fields')
  .extend(hookMetaFieldList())
  .factory()

export {
  Provider as MetaFieldProvider,
  useStore as useMetaFieldStore,
}
